import { Dropdown, Icon } from 'antd';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './index.less';

const cx = classNames.bind(styles);


const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]).isRequired,
  menu: PropTypes.element.isRequired,
};

const ActionableColumnHeader = ({
  menu,
  children,
}) => (
  <div className={cx('columnHeader')}>
    {children}
    <Dropdown overlay={menu} trigger={['click']}>
      <Icon
        type="ellipsis"
        theme="outlined"
        className={`${cx('actionIcon')} cursor-pointer`}
      />
    </Dropdown>
  </div>
);

ActionableColumnHeader.propTypes = propTypes;
export default ActionableColumnHeader;



// WEBPACK FOOTER //
// ./src/components/ui/ActionableColumnHeader/index.jsx